import { useCallback, useState } from 'react';
import { useLazyQuery } from '@apollo/client';

import AgentPortalError from 'errors/AgentPortalError';

import { TIMETABLE_SERVICES } from 'store/queries';

import { isValidTimetableServicesQuery } from 'utils/timetableServices';

const useLazyTimetableServicesQuery = () => {
  const [called, setCalled] = useState(false);
  const [timetableServicesQuery, { data, error, loading }] = useLazyQuery(TIMETABLE_SERVICES);
  const timetableServices = data?.timetableServices;

  const lazyTimetableServiceQuery = useCallback(
    ({ carrier, date, destinationUic, originUic, trainNumber }) => {
      setCalled(true);

      const isValidQuery = isValidTimetableServicesQuery({ carrier, date, destinationUic, originUic, trainNumber });

      if (!isValidQuery) {
        return;
      }

      timetableServicesQuery({ variables: { date, destinationUic, originUic, trainNumber } });
    },
    [setCalled, timetableServicesQuery]
  );

  if (error) {
    throw new AgentPortalError(error);
  }

  return [lazyTimetableServiceQuery, { timetableServices, called, loading }];
};

export default useLazyTimetableServicesQuery;
